export const TRADE_PAYOFF_MODAL_TEXT = {
  ESTIMATED_AMOUNT:
    'any estimated amount will be replaced by the most accurate payoff amount we find. Any new payoff amount will not change in-progress lending applications or completed deals.',
  PAYOFF_FOUND:
    'We found the most accurate trade payoff amount available and applied it to the deal. This quote is valid as of',
};
